import { render } from "./ThisWeeksSalesPurchasesChart.vue?vue&type=template&id=093fc11c&ts=true"
import script from "./ThisWeeksSalesPurchasesChart.vue?vue&type=script&lang=ts"
export * from "./ThisWeeksSalesPurchasesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__